import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin, SessionChange } from '@gig/magic-common';
import '@gig/magic-messaging';
import { zendeskChat } from './../../services/live-chat/zendesk/zendesk.service';
import { config } from '../../services';
import { magic } from '@gig/magic-sdk';

@Component({
    name: 'zendesk-loader',
})
export default class ZendeskLoaderComponent extends Mixins(MagicConfigMixin) {
    isLoading = false;

    get shouldShowLoader() {
        if (!config?.zendesk) {
            return false;
        }
        return this.isLoading;
    }
    
    private assignUserToZendesk() {
        const user = magic.session.getUser();
        if (user) {
            window.zE('webWidget', 'prefill', {
                name: {
                    value: `${user.firstName} ${user.lastName}`,
                    readOnly: true
                },
                email: {
                    value: user.email,
                    readOnly: true
                },
            });
            window.zE('webWidget', 'chat:addTags', ['user_authenticated']);
        }
        else {
            window.zE('webWidget', 'prefill', {
                name: {
                    value: ``,
                    readOnly: false
                },
                email: {
                    value: '',
                    readOnly: false
                },
            });
            window.zE('webWidget', 'logout');
            window.zE('webWidget', 'chat:removeTags', ['user_authenticated']);
        }
    }

    @SessionChange({ immediate: true })
    onSessionChange() {
        if (zendeskChat?.isLoaded) {
            zendeskChat?.login?.();
            this.assignUserToZendesk();
        }
    }

    created() {
        if (config?.zendesk) {
            zendeskChat?.preloadZendesk().then(async () => {
                await zendeskChat?.startingZendesk?.();
                this.assignUserToZendesk();
            });
        }
    }
}
